import React, { FC } from 'react'

import dayjs from 'dayjs'

import { Switch } from '@style-port/roov-ui-components-react'
import { RangeCalendar } from 'src/components/molecules'

type Props = {
  startDate?: Date
  endDate?: Date
  onClickDay: (input: { startDate: Date; endDate?: Date }) => void
  className?: string
}

export const RangeCalendarWithSwitches: FC<Props> = ({
  startDate,
  endDate,
  onClickDay,
  className,
}) => {
  const handleOnClickSwitch = (diff: number) => {
    const end = dayjs().toDate()
    const start = dayjs().subtract(diff, 'day').toDate()

    onClickDay({ startDate: start, endDate: end })
  }

  return (
    <div className={className}>
      <div className="tw-mx-s0 tw-flex tw-gap-s-1 tw-break-keep">
        <Switch switchType="secondary" onClick={() => handleOnClickSwitch(30)}>
          過去30日間
        </Switch>
        <Switch switchType="secondary" onClick={() => handleOnClickSwitch(90)}>
          過去90日間
        </Switch>
        <Switch switchType="secondary" onClick={() => handleOnClickSwitch(180)}>
          過去180日間
        </Switch>
      </div>
      <RangeCalendar startDate={startDate} endDate={endDate} onClickDay={onClickDay} />
    </div>
  )
}
